import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function CourseFooter() {
  const navigate = useNavigate();
  
  return (
    <div className="pt-6 border-t border-slate-100">
      <div className="flex justify-end">
        <button
          onClick={() => navigate("/courses")}
          className="cursor-pointer text-black hover:text-slate-700 text-sm font-medium inline-flex items-center gap-1"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Courses
        </button>
      </div>
    </div>
  );
}